import React from "react";
import { X } from "lucide-react";
import LabelPrinter from "./LabelPrinter";

// products: batch_items rows — extracts barcode from the stored payload's
// productIdentifiers, falls back to nothing if not present (single-mode edit
// still works for those).
const extractBarcode = (product) => product?.payload?.Orderable?.productIdentifiers?.productId || "";

const PrintLabelsModal = ({ products, onClose }) => {
    const initialItems = (products || []).map((p) => ({
        gtin: extractBarcode(p),
        title: p.title || "",
        expiration: p.expiration_date || "",
        quantity: p.quantity || 1,
        image_url: p.image_url || null,
    }));

    return (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden max-h-[90vh] flex flex-col">
                <div className="bg-gradient-to-r from-teal-500 to-blue-600 px-6 py-4 flex items-center justify-between flex-shrink-0">
                    <h2 className="text-white font-bold text-lg">Print Labels</h2>
                    <button onClick={onClose} className="text-white/70 hover:text-white"><X size={20} /></button>
                </div>
                <div className="p-4 overflow-y-auto">
                    <LabelPrinter initialItems={initialItems} />
                </div>
            </div>
        </div>
    );
};

export default PrintLabelsModal;